import { Port } from '../port/Port';

export default interface ConfigModelBase {
  '@type': DeviceType;
  iconName: string;
  isReceiveDataBin: boolean;
  isSendDataBin: boolean;
  ports: PortsConfig;
  transmissionSettings: { countsThreshold: number; every: number; recordPeriod: RecordPeriod };
  canAddRemoveSensors: boolean;
}

export enum RecordPeriod {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
}

export type PortsConfig = Record<number, Port>;

export type DeviceType =
  | 'LPMDL_1101'
  | 'LPMDL_1102'
  | 'LPMDL_1103'
  | 'LPMDL_1104'
  | 'LPMDL_1105'
  | 'LPMDL_1106'
  | 'BL_100_L'
  | 'W1'
  | 'ZENNER_MICRO'
  | 'ZENNER_EDC'
  | 'INNOTAS_WATERMETER'
  | 'MANUAL_METER'
  | 'MODBUS_SLAVE'
  | 'LOCAL_CONTROLLER'
  | 'LOCAL_CONTROLLER_GPRS'
  | 'LOCAL_CONTROLLER_1105'
  | 'LOCAL_CONTROLLER_1106'
  | 'TASMOTA'
  | 'GENERIC_LORA_WATER_METER'
  | 'LPMDL_1103_OPENLORA'
  | 'INNOTAS_HCA'
  | 'MANUAL_WATER_METER'
  | 'MANUAL_ENERGY_METER'
  | 'MANUAL_HEAT_METER'
  | 'MANUAL_GAS_METER'
  | 'TLCTL_21A4S'
  | 'FINECO_EM735'
  | 'FINECO_EM4374'
  | 'TLCTL_1104'
  | 'TLCTL_1105'
  | 'TLCTL_1106'
  | 'TLCTL_PLUG_REFOSS_P11'
  | 'TLCTL_PLUG_ATHOM_V2'
  | 'LMDL_1103'
  | 'WASTE_BIN'
  | 'WASTE_TRUCK'
  | 'AXIOMA_W1_NBIOT';
